module.exports = {
  // The application name, to be used when asking the configuration system for settings
  appName: 'CourseAssignHost', // TODO: 1. Set this to the name of the host application
  // Packages shipped as modern ES (ESM / arrow functions / class fields) that
  // webpack 2's ES5 parser and UglifyJS cannot handle, so babel must transpile
  // them too.
  childApplications: [
    '@3plearning/routing-conserve-parameters',
    '@3plearning/mx-teacher-analytics',
    '@3plearning/teacher-totter',
    'posthog-js'
  ]
};



// WEBPACK FOOTER //
// ./containers/app/app-config.js